/* Trench Market: slider, menus, parallax, cart count */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Contained parallax: each section moves its own jungle layer slower than the page */
  var plx = [].slice.call(document.querySelectorAll("[data-tm-plx]"));
  if (plx.length && !reduce) {
    var ticking = false;
    var move = function () {
      var vh = window.innerHeight;
      plx.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.bottom < -200 || r.top > vh + 200) return;
        var off = (r.top + r.height / 2 - vh / 2) * -0.45;
        var cap = r.height * 0.3;
        el.style.setProperty("--plx", Math.max(-cap, Math.min(cap, off)).toFixed(1) + "px");
      });
      ticking = false;
    };
    window.addEventListener("scroll", function () { if (!ticking) { ticking = true; requestAnimationFrame(move); } }, { passive: true });
    window.addEventListener("resize", move);
    move();
  }

  /* Dropdowns: tap to open on touch screens, Escape to close */
  document.querySelectorAll('[data-tm-drop]').forEach(function (drop) {
    var trigger = drop.firstElementChild;
    var close = function () { drop.classList.remove('is-open'); trigger.setAttribute('aria-expanded', 'false'); };
    trigger.addEventListener('click', function (e) {
      var touch = window.matchMedia('(hover: none)').matches;
      if (trigger.tagName === 'BUTTON' || (touch && !drop.classList.contains('is-open'))) {
        e.preventDefault();
        var open = !drop.classList.contains('is-open');
        document.querySelectorAll('[data-tm-drop].is-open').forEach(function (d) { d.classList.remove('is-open'); });
        drop.classList.toggle('is-open', open);
        trigger.setAttribute('aria-expanded', String(open));
      }
    });
    drop.addEventListener('mouseenter', function () { trigger.setAttribute('aria-expanded', 'true'); });
    drop.addEventListener('mouseleave', close);
    drop.addEventListener('keydown', function (e) { if (e.key === 'Escape') { close(); trigger.focus(); } });
  });
  document.addEventListener('click', function (e) {
    if (!e.target.closest('[data-tm-drop]')) {
      document.querySelectorAll('[data-tm-drop].is-open').forEach(function (d) {
        d.classList.remove('is-open');
        d.firstElementChild.setAttribute('aria-expanded', 'false');
      });
    }
  });

  /* Mobile menu */
  var burger = document.querySelector('[data-tm-burger]');
  var mnav = document.querySelector('[data-tm-mnav]');
  if (burger && mnav) {
    var shut = function () { mnav.hidden = true; burger.setAttribute('aria-expanded', 'false'); document.documentElement.style.overflow = ''; burger.focus(); };
    burger.addEventListener('click', function () {
      mnav.hidden = false; burger.setAttribute('aria-expanded', 'true'); document.documentElement.style.overflow = 'hidden';
      var first = mnav.querySelector('a, summary'); if (first) first.focus();
    });
    mnav.querySelector('[data-tm-mnav-close]').addEventListener('click', shut);
    mnav.addEventListener('keydown', function (e) { if (e.key === 'Escape') shut(); });
  }

  /* Slider */
  document.querySelectorAll('[data-tm-slider]').forEach(function (root) {
    var track = root.querySelector('[data-tm-track]');
    var slides = root.querySelectorAll('[data-tm-slide]');
    var dots = root.querySelectorAll('[data-tm-dot]');
    if (slides.length < 2) return;
    var i = 0, timer = null;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 6000;
    var auto = root.getAttribute('data-autoplay') === 'true' && !reduce;
    var go = function (n) {
      i = (n + slides.length) % slides.length;
      track.style.transform = 'translateX(' + (-100 * i) + '%)';
      slides.forEach(function (s, k) {
        s.setAttribute('aria-hidden', k === i ? 'false' : 'true');
        s.querySelectorAll('a').forEach(function (a) { a.tabIndex = k === i ? 0 : -1; });
      });
      dots.forEach(function (d, k) { d.setAttribute('aria-current', k === i ? 'true' : 'false'); });
    };
    var stop = function () { if (timer) { clearInterval(timer); timer = null; } };
    var start = function () { stop(); if (auto) timer = setInterval(function () { go(i + 1); }, interval); };
    root.querySelector('[data-tm-prev]').addEventListener('click', function () { go(i - 1); start(); });
    root.querySelector('[data-tm-next]').addEventListener('click', function () { go(i + 1); start(); });
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-tm-dot'), 10)); start(); }); });
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    var x0 = null;
    track.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; stop(); }, { passive: true });
    track.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0; x0 = null;
      if (Math.abs(dx) > 40) go(dx < 0 ? i + 1 : i - 1);
      start();
    });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stop(); else start(); });
    go(0); start();
  });

  /* Cart count follows add-to-cart */
  var count = document.querySelector('[data-tm-cart-count]');
  if (count) {
    var refresh = function () {
      fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) { count.textContent = c.item_count; count.hidden = c.item_count === 0; })
        .catch(function () {});
    };
    ['cart:update', 'cart:updated', 'cart-update'].forEach(function (ev) { document.addEventListener(ev, refresh); });
  }
})();

